import { render, staticRenderFns } from "./HomeBody.vue?vue&type=template&id=240f1766&scoped=true&"
import script from "./HomeBody.vue?vue&type=script&lang=js&"
export * from "./HomeBody.vue?vue&type=script&lang=js&"
import style0 from "./HomeBody.vue?vue&type=style&index=0&id=240f1766&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f1766",
  null
  
)

export default component.exports